import React from 'react'
import Reveal from './Reveal'

function SectionHead({ kicker, title, lead, id }) {
  return (
    <Reveal as="header" className="section-head">
      <p className="kicker">{kicker}</p>
      <h2 id={id}>{title}</h2>
      {lead && <p className="section-lead">{lead}</p>}
    </Reveal>
  )
}

export default SectionHead
